import { render, staticRenderFns } from "./AmountCard.vue?vue&type=template&id=3dff2cd3&"
import script from "./AmountCard.vue?vue&type=script&lang=js&"
export * from "./AmountCard.vue?vue&type=script&lang=js&"
import style0 from "./AmountCard.vue?vue&type=style&index=0&id=3dff2cd3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports